module.exports = __webpack_public_path__ + "img/power-pro-elite-plus.b8c50cc4.svg";